import { render, staticRenderFns } from "./MediaUpdateForHomeAppDialog.vue?vue&type=template&id=1ef402ef&scoped=true"
import script from "./MediaUpdateForHomeAppDialog.vue?vue&type=script&lang=js"
export * from "./MediaUpdateForHomeAppDialog.vue?vue&type=script&lang=js"
import style0 from "./MediaUpdateForHomeAppDialog.vue?vue&type=style&index=0&id=1ef402ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef402ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef402ef')) {
      api.createRecord('1ef402ef', component.options)
    } else {
      api.reload('1ef402ef', component.options)
    }
    module.hot.accept("./MediaUpdateForHomeAppDialog.vue?vue&type=template&id=1ef402ef&scoped=true", function () {
      api.rerender('1ef402ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/MediaUpdateForHomeAppDialog.vue"
export default component.exports